import { GridHeaders } from '@project-types/GridHeaders';
import { SkuReportGridData } from '@pages/reporting-pages/deliveries-sku/types/SkuReportGridData';



export const headersObject: GridHeaders<SkuReportGridData> = [
	{ label: '', key: '', width: 'auto' },
	{ label: 'Země', key: 'country', width: '1fr' },
	{ label: 'SKU', key: 'materialClientId', width: '1fr' },
	{ label: 'Název', key: 'materialName', width: '1fr' },
	
	{ label: 'Objem celkem [hl]', key: 'totalVolume', width: '1fr' },
	{ label: 'Objem ON [hl]', key: 'onTradeVolume', width: '1fr' },
	{ label: 'Obejm OFF [hl]', key: 'offTradeVolume', width: '1fr' },
]